(function (global, factory) {
  typeof exports === "object" && typeof module !== "undefined"
    ? factory(exports)
    : typeof define === "function" && define.amd
    ? define(["exports"], factory)
    : ((global = typeof globalThis !== "undefined" ? globalThis : global || self), factory((global.hsApi = {})));
})(this, function (exports) {
  "use strict";

  /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
  /* global Reflect, Promise */

  var __assign = function () {
    __assign =
      Object.assign ||
      function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
    return __assign.apply(this, arguments);
  };

  function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function (resolve) {
            resolve(value);
          });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  }

  function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function () {
          if (t[0] & 1) throw t[1];
          return t[1];
        },
        trys: [],
        ops: [],
      },
      f,
      y,
      t,
      g;
    return (
      (g = { next: verb(0), throw: verb(1), return: verb(2) }),
      typeof Symbol === "function" &&
        (g[Symbol.iterator] = function () {
          return this;
        }),
      g
    );
    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while ((g && ((g = 0), op[0] && (_ = 0)), _))
        try {
          if (
            ((f = 1),
            y &&
              (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) &&
              !(t = t.call(y, op[1])).done)
          )
            return t;
          if (((y = 0), t)) op = [op[0] & 2, t.value];
          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;
            case 4:
              _.label++;
              return { value: op[1], done: false };
            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;
            case 7:
              op = _.ops.pop();
              _.trys.pop();
              continue;
            default:
              if (!((t = _.trys), (t = t.length > 0 && t[t.length - 1])) && (op[0] === 6 || op[0] === 2)) {
                _ = 0;
                continue;
              }
              if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                _.label = op[1];
                break;
              }
              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }
              if (t && _.label < t[2]) {
                _.label = t[2];
                _.ops.push(op);
                break;
              }
              if (t[2]) _.ops.pop();
              _.trys.pop();
              continue;
          }
          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
      if (op[0] & 5) throw op[1];
      return { value: op[0] ? op[1] : void 0, done: true };
    }
  }

  function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2)
      for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
        }
      }
    return to.concat(ar || Array.prototype.slice.call(from));
  }

  /**
   * 判断 app 版本 是否在 minVersion ~ maxVersion 之间, 含端点
   */
  var checkVersion = function (_a) {
    var min = _a.min,
      max = _a.max,
      mustDreoApp = _a.mustDreoApp;
    var _b = window.hsJSBridge || {},
      _isDreoApp = _b._isDreoApp,
      _appVersion = _b._appVersion;
    if (mustDreoApp && !_isDreoApp) {
      return false;
    }
    if (_appVersion && min && _appVersion < min) {
      return false;
    }
    if (_appVersion && max && _appVersion > max) {
      return false;
    }
    return _appVersion ? true : undefined;
  };

  var NOOP = function () {};
  function randomString(len) {
    len = len || 32;
    var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
    var a = t.length;
    var res = "";
    for (var i = 0; i < len; i++) res += t.charAt(Math.floor(Math.random() * a));
    return res;
  }
  // 生成 回调方法名
  function genCallbackFunName(funName) {
    var timestamp = Date.now().toString(16).slice(3);
    return ["_cb", funName || "", timestamp, randomString(12)].join("_");
  }
  function isIosWebview() {
    var _a;
    return !!((_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers);
  }
  function isAndroid() {
    return navigator.userAgent.toLowerCase().includes("android");
  }
  // app 版本
  function getAppVersion() {
    var _a;
    return ((_a = window.hsJSBridge) === null || _a === void 0 ? void 0 : _a._appVersion) || "";
  }

  function appUaParse() {
    var ua = (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || "";
    // 安卓 hesung(com.hesung.dreo.debug)/2.1.1
    // ios hesung(2.1.1/com.hesung.dreo.debug)
    var reg = /((\d+.\d+.\d+)\/)?(com\.hesung\.dreo(\.\w*)*)\)(\/(\d+.\d+.\d+))?/i;
    var match = ua.match(reg);
    return {
      _isDreoApp: !!match,
      _appPackageName: match ? match[3] : undefined,
      _versionType: match ? (match[4] || "").replace(/^\./, "") : undefined,
      _appVersion: match ? match[2] || match[6] : undefined,
    };
  }

  var warn = 1
    ? NOOP
    : function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        console.warn.apply(console, __spreadArray(["[@hsfe/dreojsapi]"], args, false));
      };
  var hasWarned = {};
  function warnOnce(msg) {
    var isNodeProd = typeof process !== "undefined" && 1;
    if (!isNodeProd && !hasWarned[msg]) {
      hasWarned[msg] = true;
      warn(msg);
    }
  }
  var log = 1
    ? NOOP
    : function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        console.log.apply(console, __spreadArray(["[@hsfe/dreojsapi]"], args, false));
      };

  /**
   * 封装 和 APP 通信基础接口
   */
  // 接口返回状态码
  var RES_CODE = {
    // 取消操作
    CANCEL: "-1",
    // 接口调用成功, 不含数据, 仅表示掉接口成功
    ACK: "0",
    // 成功回调
    SUCCESS: "1",
  };
  // 待回调 集合
  var callbacks = {};
  var eventCbs = {};
  function ignoreAck(code) {
    var _appVersion = window.hsJSBridge._appVersion || "";
    return code == RES_CODE.ACK && _appVersion < "2.1.1";
  }
  function isSuccess(code) {
    var _appVersion = window.hsJSBridge._appVersion || "";
    return code == RES_CODE.SUCCESS || (_appVersion >= "2.1.1" && code == RES_CODE.ACK);
  }
  // 回调 后, 从callbacks 中移除记录
  function invokeCallback(funName, cbOptions) {
    log("invokeCallback", funName, cbOptions);
    var res = JSON.parse(cbOptions);
    var cb = callbacks[res.callback];
    /**
     * 2.1.1 之前版本, 掉用接口后可能 有两次返回 一次code = 0 表示调用成功无返回值, code = 1 表示成功含返回值
     * 2.1.1 及之后版本 code 0,1 均表示成功, 同一接口只有一次 成功回调, 但安卓和ios code 可能不一致
     */
    if (!ignoreAck(res.code)) {
      delete callbacks[res.callback];
    }
    cb === null || cb === void 0 ? void 0 : cb(res);
  }
  /**
   * 接受监听事件
   * @example app 执行: hsJSBridge._listenerCallback('{"callback": "listenerBack","data":{}}')
   */
  function listenerCallback(cbOptions) {
    log("listenerCallback", cbOptions);
    var res = JSON.parse(cbOptions);
    var cb = eventCbs[res.callback];
    cb === null || cb === void 0 ? void 0 : cb(res);
    console.log(cbOptions, cb, res.callback, "---------App 执行回调-------");
  }
  var isInit = false;
  function jsBridgeInit() {
    if (typeof window === "object" && !isInit) {
      var info = appUaParse();
      // 安卓app 原生 注入 hsJSBridge.invoke 方法
      if (isIosWebview()) {
        // ios app js 添加 hsJSBridge.invoke 方法
        window.hsJSBridge = {
          invoke: function (options) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.webkit.messageHandlers.invoke.postMessage(options);
          },
          _invokeCallback: invokeCallback,
        };
      } else if (window.hsJSBridge == undefined) {
        window.hsJSBridge = {
          invoke: function (options) {
            var reqData = JSON.parse(options);
            warnOnce("dreoJsApi 需在 Dreo App 才能使用");
            invokeCallback(
              reqData.action,
              JSON.stringify({
                callback: reqData.callback,
                code: "-99",
                action: reqData.action,
                msg: "dreoJsApi 需在 Dreo App 才能使用",
              })
            );
          },
        };
      }
      var hsBridge = window.hsJSBridge;
      // 添加 回调入口
      hsBridge._invokeCallback = invokeCallback;
      hsBridge._listenerCallback = listenerCallback;
      hsBridge._isDreoApp = info._isDreoApp;
      hsBridge._appPackageName = info._appPackageName;
      hsBridge._appVersion = info._appVersion || "";
      hsBridge._versionType = info._versionType;
      isInit = true;
    }
  }
  jsBridgeInit();
  /**
     * app 通信接口
     * @example invoke('getAppInfo')
     * app 执行 hsJSBridge.invokeCallback 返回结果
     * hsJSBridge.invokeCallback('getDeviceInfo', `{
         "callback": "_cb_getAppInfo_bcJ44wcdHp37JbEnjkcny",
         "code":"1","msg":"0k","data":{"appToken": "", "h5Token": ""}
       }`)
     */
  function invoke(funName, data, cbs, options) {
    var cbName = genCallbackFunName(funName);
    var callNative = function () {
      var options = JSON.stringify({
        action: funName,
        callback: cbName,
        data: data,
      });
      try {
        // console.log('callNativeInvoke', funName, options)
        // 适配旧版本
        if (window === null || window === void 0 ? void 0 : window.NativeBridge) {
          var sendMsg = data || {};
          window.NativeBridge.invoke(funName, sendMsg, function (a) {
            invokeCallback(funName, JSON.stringify(__assign(__assign({}, a), { callback: cbName })));
          });
        } else if (window.hsJSBridge) {
          window.hsJSBridge.invoke(options);
        } else {
          warn("callNativeInvoke", funName, options);
        }
      } catch (err) {
        console.error("callNativeInvoke", funName, err);
      }
    };
    if (!cbs) {
      return new Promise(function (resolve, reject) {
        callbacks[cbName] = function (res) {
          if (isSuccess(res.code)) {
            var resData = (options === null || options === void 0 ? void 0 : options.transformRes)
              ? options.transformRes(res.data)
              : res.data;
            resolve(resData);
          } else if (res.code != RES_CODE.ACK) {
            reject(res);
          }
        };
        callNative();
      });
    }
    callbacks[cbName] = function (res) {
      var _a, _b, _c;
      if (isSuccess(res.code)) {
        var resData = (options === null || options === void 0 ? void 0 : options.transformRes)
          ? options.transformRes(res.data)
          : res.data;
        (_a = cbs.success) === null || _a === void 0 ? void 0 : _a.call(cbs, resData);
      } else if (res.code == RES_CODE.ACK) {
        return;
      } else {
        (_b = cbs.fail) === null || _b === void 0 ? void 0 : _b.call(cbs, res);
      }
      (_c = cbs.complete) === null || _c === void 0 ? void 0 : _c.call(cbs);
    };
    callNative();
    return;
  }
  function registerListener(funName, cb) {
    eventCbs[funName] = cb;
  }
  function removeListener(funName) {
    delete eventCbs[funName];
  }
  // export { invoke }
  // 模拟 invoke cb 返回结构
  function simulationCb(success, cbs, data) {
    var _a, _b, _c;
    if (cbs) {
      if (success) {
        (_a = cbs.success) === null || _a === void 0 ? void 0 : _a.call(cbs, data);
      } else {
        (_b = cbs.fail) === null || _b === void 0 ? void 0 : _b.call(cbs, data);
      }
      (_c = cbs.complete) === null || _c === void 0 ? void 0 : _c.call(cbs);
    } else {
      if (success) {
        return Promise.resolve();
      } else {
        return Promise.reject();
      }
    }
  }

  function getDeviceInfo(cbs) {
    return invoke("getDeviceInfo", undefined, cbs, {
      transformRes: function (data) {
        // 安卓 2.1.1 app 高度返回 错误兼容
        if (
          (data === null || data === void 0 ? void 0 : data.statusBarHeight) > 50 &&
          isAndroid() &&
          getAppVersion() <= "2.1.1"
        ) {
          data.statusBarHeight = data.statusBarHeight / window.devicePixelRatio;
        }
        return data;
      },
    });
  }
  function getAppInfo(cbs) {
    return invoke("getAppInfo", undefined, cbs);
  }
  function setWebviewConfig(params, cbs) {
    return invoke("config", params, cbs);
  }
  function getDeviceList(cbs) {
    return invoke("getDeviceList", undefined, cbs);
  }
  function share(params, cbs) {
    return invoke("share", params, cbs);
  }
  function login(cbs) {
    return invoke("login", {}, cbs);
  }
  function showDialog(params, cbs) {
    return invoke("showDialog", params, cbs);
  }

  function close(params, cbs) {
    return invoke("close", params, cbs);
  }
  function goBack(cbs) {
    var _a;
    var _appVersion = window.hsJSBridge._appVersion || "";
    if (!_appVersion || _appVersion < "2.1.1") {
      history.back();
      return cbs
        ? (_a = cbs.success) === null || _a === void 0
          ? void 0
          : _a.call(cbs, undefined)
        : Promise.resolve();
    }
    return invoke("goBack", undefined, cbs);
  }
  function push(_a, cbs) {
    var _b;
    var target = _a.target,
      fullScreen = _a.fullScreen,
      url = _a.url;
    var str;
    if (target === "inside") {
      str = "dreo://nav/Webview/browser?";
      if (fullScreen) {
        str += "fullScreen=true&";
      }
      str += "url=" + encodeURI(url);
    } else if (target === "outside") {
      str = checkVersion({ min: "2.1.3" }) ? "dreo://biz/webview/openBrowser?url=" + encodeURI(url) : url;
    } else {
      str = url;
    }
    if (!((_b = window.hsJSBridge) === null || _b === void 0 ? void 0 : _b._isDreoApp) && url.startsWith("http")) {
      location.href = url;
      return simulationCb(true, cbs);
    }
    return invoke(
      "router",
      {
        url: str,
      },
      cbs
    );
  }
  /**
   * 生成 dreo app 支持的url
   */
  function genDreoUri(_a) {
    var target = _a.target,
      fullScreen = _a.fullScreen,
      url = _a.url;
    var str;
    if (target === "inside") {
      str = "dreo://nav/Webview/browser?";
      if (fullScreen) {
        str += "fullScreen=true&";
      }
      /*    if (cacheType != undefined) {
              str += `cacheType=${cacheType}&`
            }*/
      str += "url=" + encodeURI(url);
    } else if (target === "outside") {
      str = checkVersion({ min: "2.1.3" }) ? "dreo://biz/webview/openBrowser?url=" + encodeURI(url) : url;
    } else {
      str = url;
    }
    return str;
  }
  var listenerBackFunName = "listenerBack";
  var listenerPageHiddenFunName = "listenerPageHidden";
  var listenerPageVisibleFunName = "listenerPageVisible";
  /**
   * 禁用返回 并 监听返回
   * @param cb
   */
  function listenerBack(cb) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [
              4 /*yield*/,
              setWebviewConfig({
                listenerBack: listenerBackFunName,
                sideSwipe: false,
              }),
            ];
          case 1:
            _a.sent();
            registerListener(listenerBackFunName, cb);
            return [2 /*return*/];
        }
      });
    });
  }
  /**
   * 允许返回 并 移除返回监听
   */
  function unListenerBack() {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [
              4 /*yield*/,
              setWebviewConfig({
                listenerBack: "",
                sideSwipe: true,
              }),
            ];
          case 1:
            _a.sent();
            removeListener(listenerBackFunName);
            return [2 /*return*/];
        }
      });
    });
  }
  /**
   * 页面显示监听
   * @param cb
   */
  function listenerPageVisible(cb) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [
              4 /*yield*/,
              setWebviewConfig({
                listenerPageVisible: listenerPageVisibleFunName,
                // listenerBack: listenerPageVisibleFunName,
              }),
            ];
          case 1:
            _a.sent();
            registerListener(listenerPageVisibleFunName, cb);
            return [2 /*return*/];
        }
      });
    });
  }
  /**
   *  移除页面显示监听
   */
  function unListenerPageVisible() {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [
              4 /*yield*/,
              setWebviewConfig({
                listenerPageVisible: "",
              }),
            ];
          case 1:
            _a.sent();
            removeListener(listenerPageVisibleFunName);
            return [2 /*return*/];
        }
      });
    });
  }
  /**
   * 页面隐藏监听
   * @param cb
   */
  function listenerPageHidden(cb) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [
              4 /*yield*/,
              setWebviewConfig({
                listenerPageHidden: listenerPageHiddenFunName,
              }),
            ];
          case 1:
            _a.sent();
            registerListener(listenerPageHiddenFunName, cb);
            return [2 /*return*/];
        }
      });
    });
  }
  /**
   *  移除页面隐藏监听
   */
  function unListenerPageHidden() {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [
              4 /*yield*/,
              setWebviewConfig({
                listenerPageHidden: "",
              }),
            ];
          case 1:
            _a.sent();
            removeListener(listenerPageHiddenFunName);
            return [2 /*return*/];
        }
      });
    });
  }

  var router = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    close: close,
    genDreoUri: genDreoUri,
    goBack: goBack,
    listenerBack: listenerBack,
    listenerPageHidden: listenerPageHidden,
    listenerPageVisible: listenerPageVisible,
    push: push,
    unListenerBack: unListenerBack,
    unListenerPageHidden: unListenerPageHidden,
    unListenerPageVisible: unListenerPageVisible,
  });

  function kcm(params, cbs) {
    return invoke("kcm", params, cbs);
  }

  var c1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    kcm: kcm,
  });

  exports.NOOP = NOOP;
  exports.RES_CODE = RES_CODE;
  exports.c1 = c1;
  exports.checkVersion = checkVersion;
  exports.close = close;
  exports.genCallbackFunName = genCallbackFunName;
  exports.genDreoUri = genDreoUri;
  exports.getAppInfo = getAppInfo;
  exports.getAppVersion = getAppVersion;
  exports.getDeviceInfo = getDeviceInfo;
  exports.getDeviceList = getDeviceList;
  exports.goBack = goBack;
  exports.invoke = invoke;
  exports.isAndroid = isAndroid;
  exports.isIosWebview = isIosWebview;
  exports.jsBridgeInit = jsBridgeInit;
  exports.listenerBack = listenerBack;
  exports.listenerPageHidden = listenerPageHidden;
  exports.listenerPageVisible = listenerPageVisible;
  exports.login = login;
  exports.push = push;
  exports.registerListener = registerListener;
  exports.removeListener = removeListener;
  exports.router = router;
  exports.setWebviewConfig = setWebviewConfig;
  exports.share = share;
  exports.showDialog = showDialog;
  exports.simulationCb = simulationCb;
  exports.unListenerBack = unListenerBack;
  exports.unListenerPageHidden = unListenerPageHidden;
  exports.unListenerPageVisible = unListenerPageVisible;
});


